module.exports = __webpack_public_path__ + "static/317932249_666023378527434_6870253941256497314_n.jpg-1671186392485-febc25987daa740bea56986f5f4c0669.webp";